import angular from 'angular';
import uiMenu from './uiMenu/uiMenu';
import uiHeader from './uiHeader/uiHeader';
import uiFooter from './uiFooter/uiFooter';
import shotValidator from './directives/shotValidator.directive';
import imageWithPreview from './directives/imageWithPreview.directive';
import autoFocus from  './directives/autoFocus.directive';

let commonModule = angular.module('app.common', [
	uiMenu,
	uiHeader,
	uiFooter,
])
.directive({shotValidator,imageWithPreview,autoFocus})
.name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js